import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import axios from 'axios'
// 公共组件 侧边栏 顶部 底部
import Main from '@/components/Main'
//登录页
import login from '@/login/login.vue'
import NotFound from '@/publicComponents/notFound.vue'
import globalPath from '@/assets/script/globalPath'
import common from '@/assets/script/common.js'
// LoginSuccessful
Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/loginSuccess',
      name: 'loginSuccess',
      component:  (resolve) => require (['@/login/loginSuccess'],resolve)
    },
    {
      path: '/print',
      name: 'print',
      component:  (resolve) => require (['@/PrintingInterface/index'],resolve)
    },
    {
      path: '/',
      component: Main,
      meta: {
        requireAuth: true
      },
      children: [{
          path: "/",
          redirect: '/home'
        },
      ]
    },
  ]
});
let router_lise = [];

// 未登录路由拦截
router.beforeEach((to,from,next)=>{
  let isLogin = common.getCookie('tibiot-crm'); // 获取token
  //路由设置
  if (isLogin) {
    if (router_lise.length == 0) {
      if(to.path === '/loginSuccess' && to.query.param){
        let param = JSON.parse(to.query.param);
        if(param.token && param.staffName){
          // 设置浏览器 唯一标识
          document.cookie = "uniquePageKey = true;path=/;domain=tibiot.com";
          document.cookie = "tibiot-crm="+ param.token +";path=/;"
          store.commit('setRoles', param.roles);
          store.commit('setUserName', param.staffName);
          store.commit('setLeaderFirst', param.leaderFirst);
          store.commit('setStaffCode', param.staffCode);
          store.commit('setStaffStatus', param.staffStatus);
          store.commit('setDeptCode', param.deptCode);
          store.commit('setBusinessLine', data.businessLine);
          getRouters(to,from, next);
        }else{
          let params = {
            toSystemCode : param.sysCode,
            accessToken : param.authToken
          };
          console.log("router : params");
          console.log( params);
          axios({
            method: 'get',
            url: globalPath.globalPath.Sso + 'admin/without/skip/get/context',
            params: params
          }).then(res =>{
            let data = res.data.data;
            console.log("router: data");
            console.log(data);
            // 设置浏览器 唯一标识
            document.cookie = "uniquePageKey = true;path=/;domain=tibiot.com";
            document.cookie = "tibiot-crm="+ data.token +";path=/;"
            store.commit('setRoles', data.roles);
            store.commit('setUserName', data.staffName);
            store.commit('setLeaderFirst', data.leaderFirst);
            store.commit('setStaffCode', data.staffCode);
            store.commit('setStaffStatus', data.staffStatus);
            store.commit('setDeptCode', data.deptCode);
            store.commit('setBusinessLine', data.businessLine);
            getRouters(to,from, next);
          }).catch(err => {
            getRouters(to,from, next);
          })
        }
      }else{
        getRouters(to,from, next);
      }
    } else {
      if (to.path == '/404') {
        next({path: '/home'})
      } else {
        next()
      }
    }
  }else {
    if (to.path === '/login' || to.path === '/loginSuccess' || to.path === '/print') {
      router_lise = [];
      next();
      
    } else {
      router_lise = [];
      next({path: "/login"})
    }
  }
  
  //判断是否login页面
  if (to.fullPath != '/login') {
    //获取面包屑
    getCrumbs(to);
    // //获取当前页面的按钮权限
    getMuneBtn(to);
  }
});
router.onError((error) => {
  console.log('error:'+ error.message); 
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
  }else{
    console.log(error)
  }
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//获取当前页面的按钮权限
function getMuneBtn(to){
  if (to.meta.index) { //当前菜单的id;
    axios({
      method: 'get',
      url: globalPath.globalPath.IgwIam + 'menu/getSysMenuBtnRole?menuCode='+to.meta.index,
      heads : {
        'content-type' : 'application/json',
        'Accept-Language':'zh-CN'
      }
    })
    .then(function (res) {
      if (res.data.code == 200) {
        store.commit('setButtons', res.data.data);//存储页面的按钮
      }
    })
    .catch(() => console.log('promise catch err'));
  }
}

//获取面包屑
function MBX(to){
  let arrmenu = store.state.menu;
  let MbxArrs = [];
  for(let i=0; i < arrmenu.length; i++){
    let URL = arrmenu[i].menuUrl;
    if(URL == to.path){
      MbxArrs[0] = arrmenu[i].menuName;
      return MbxArrs;
    }else{
        if(arrmenu[i].children){
            for(let j = 0; j < arrmenu[i].children.length; j++){
                let TwoURL = arrmenu[i].children[j].menuUrl;
                if(TwoURL.substr(TwoURL.lastIndexOf('/')) == to.path){
                  MbxArrs[0] = arrmenu[i].menuName;
                  MbxArrs[1] = arrmenu[i].children[j].menuName;
                  return MbxArrs;
                }else{
                  if(arrmenu[i].children[j].children){
                    for(let k = 0; k < arrmenu[i].children[j].children.length; k++){
                      let TURL = arrmenu[i].children[j].children[k].menuUrl;
                      if(TURL.substr(TURL.lastIndexOf('/')) == to.path){
                        MbxArrs[0] = arrmenu[i].menuName;
                        MbxArrs[1] = arrmenu[i].children[j].menuName;
                        MbxArrs[2] = arrmenu[i].children[j].children[k].menuName;
                        return MbxArrs;
                      }
                    }
                   }
                }
            }
        }
    }
  }
  return MbxArrs;
}
function getCrumbs(to){
  let MbxArrs = MBX(to);
  if(!MbxArrs.length){
    if(to.path == '/personalInfo'){
      MbxArrs[0] = '个人中心';
    }else{
      MbxArrs[0] = '首页';
    }
  }
  store.commit('setCrumbsArr',MbxArrs);
}
//获取路由
function getRouters(to, from, next){
  router_lise = [];
  axios({
    method: 'get',
    url: globalPath.globalPath.IgwIam + 'menu/getSysMenuRoute',
    heads : {
      'content-type' : 'application/json',
      'Accept-Language':'zh-CN'
    }
  })
  .then(function (res) {
      if(res.data.code == 200 && res.data.data.length != 0){
        router_lise = addDynamicRoutes(res.data.data);
        router.options.routes[3].children = router_lise;
        router.options.routes[4] = {path:'/404', name:'404', component: NotFound};
        router.options.routes[5] = {path: '*', redirect: '/404'};
        router.matcher = new Router().matcher;
        
        router.addRoutes(router.options.routes);
  
        if(from.path == '/login' || from.path == '/'){
          next({path: "/home"});
        }else{
          next({...to});
        }
      }else{
        if (to.path === '/login') {
          next()
        } else {
          next({path: "/login"})
        }
      }
  }).catch(function (err) {
    if (to.path === '/login') {
      next()
    } else {
      next({path: "/login"})
    }
  })
}
//整理路由格式
function addDynamicRoutes (menuList = [], routes = []) {
  for(var i = 0; i < menuList.length; i++){
    if(menuList[i].menuUrl){
      let url = menuList[i].menuUrl;
      let route = {
        path: url.substr(url.lastIndexOf('/')),
        name: url.substr(url.lastIndexOf('/')+1),
        component:  (resolve) => require([`@/views${url}`],resolve),
        meta: {
          index : menuList[i].menuCode,
          name : menuList[i].menuName
        }
      };
      routes.push(route);
    }
  }
  // routes.push({
  //   path:"/fileDownloadMag",
  //   name:'fileDownloadMag',
  //   component:  (resolve) => require (['@/views/fileDownloadMag'],resolve),
  //   meta: {
  //     index : 40,
  //     name : '文件下载中心'
  //   }
  // });
  routes.push({
    path:"/personalInfo",
    name:'personalInfo',
    component:  (resolve) => require (['@/views/personalInfo'],resolve),
    meta: {
      index : 167,
      name : '个人中心'
    }
  })
  return routes
}


export default router



// WEBPACK FOOTER //
// ./src/router/index.js